module.exports = __webpack_public_path__ + "static/media/hic_logo.31764116.svg";